import React from "react";
import logo from "../assets/avatar.png";
import { useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Copyright from "@mui/icons-material/Copyright";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import tokyoMap from "../assets/tokyo-map.png";

const Home = () => {
  const navigate = useNavigate();

  function navTokyo() {
    navigate("/tokyo");
  }
  return (
    <div>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${logo})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h1>DANIEL AMES</h1>

            <Box noValidate sx={{ mt: 1 }}>
              <Card
                sx={{
                  maxWidth: 345,
                  padding: 1,
                  marginTop: 1,
                  fontFamily: "Futura",
                }}
              >
                Hi, I'm Daniel Ames, digital artist and developer. I'm
                interested in exploring the synergy between technology and art,
                and how it can be used to create immersive and engaging
                experiences. Currently learning and creating with Blender.
                <br></br>
                <a href="https://danie1ames.artstation.com/">My portfolio</a>
                <br></br>
                You can follow my creative journey on{" "}
                <a href="https://twitter.com/danie1ames">my Twitter</a> and{" "}
                <a href="https://www.instagram.com/danie1ames/">Instagram</a>. I
                also occasionally share my process and tips on{" "}
                <a href="https://www.tiktok.com/@danie1ames">my TikTok</a>.
                <br></br>I would be thrilled to have you join me on this journey
                and to see how my art evolves over time. I look forward to
                connecting with talented artists here, to share, inspire and get
                inspired ✨
              </Card>
              <h3>Projects</h3>
              <Card sx={{ maxWidth: 345 }} variant="outline">
                <CardActionArea onClick={navTokyo}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={tokyoMap}
                    alt="tokyo map"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Tokyo Explorer - Discover the City District by District
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Discover Tokyo like never before with Tokyo Explorer. Our
                      interactive map provides you with an overview of each of
                      the city's 23 special wards, including key landmarks and
                      districts. Plan your trip and navigate the city with ease
                      using Tokyo Explorer as your guide.
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>

              <Box
                sx={{
                  mt: 10,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Copyright sx={{ pr: 1, fontFamily: "Futura" }} /> 2023
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default Home;
